import { createAction } from "redux-act";
import { createRoutine } from "../utils/routine.utils";
export var signUp = createRoutine("AUTH_SIGN_UP");
export var signUpVerifyPhone = createRoutine("AUTH_SIGN_UP_VERIFY_PHONE");
export var signUpVerifiedEmail = createAction("AUTH_SIGN_UP_VERIFY_EMAIL");
export var signUpRequestTokenFromEmail = createAction("AUTH_SIGN_UP_REQUEST_TOKEN_FROM_EMAIL");
export var signUpResendVerificationEmail = createAction("AUTH_SIGN_UP_RESEND_VERIFICATION_EMAIL");
export var signUpResendVerificationSms = createAction("AUTH_SIGN_UP_RESEND_VERIFICATION_SMS");
export var getUser = createRoutine("AUTH_USER_GET");
export var updateUser = createRoutine("AUTH_USER_UPDATE");
export var updateUserById = createRoutine("AUTH_USER_UPDATE_BY_ID");
export var adminVerifyEmail = createRoutine("AUTH_ADMIN_VERIFY_EMAIL");
export var adminVerifyPhone = createRoutine("AUTH_ADMIN_VERIFY_PHONE");
export var removeProfile = createRoutine("AUTH_USER_REMOVE_PROFILE");
